import { AcdQueue, Queue, QueueInput } from '../../graphql/components';

import type { Values } from './types';

export const formatQueueTag = (name?: string | null) => {
  if (!name) {
    return name;
  }

  return name.replaceAll(' ', '_').toUpperCase();
};

export const createQueueFromValues = (values: Values): QueueInput => ({
  acdQueueIds: values.acdQueueIds ?? [],
  name: values.name,
  skillId: values.skillId || null,
  serviceLevel:
    values.interval &&
    !Number.isNaN(values.interval) &&
    typeof values.percentage === 'number' &&
    !Number.isNaN(values.percentage)
      ? {
          interval: values.interval,
          percentage: values.percentage * 100,
        }
      : undefined,
  used: values.used,
  channelType: values.channelType,
  tag: formatQueueTag(values.tag) as string,
  timezone: values.timezone,
});

export const createValuesFromQueue = (queue: Queue): Values => ({
  acdQueueIds: queue.acdQueueIds || [],
  acdQueueIdsEditable: queue.acdQueueIdsEditable,
  assignedIds: undefined,
  channelType: queue.channelType,
  channelTypeEditable: queue.channelTypeEditable,
  id: queue.id,
  interval: queue.serviceLevel?.interval ?? NaN,
  name: queue.name,
  nameEditable: queue.nameEditable,
  // Loose equality to cover both `null` and `undefined`
  percentage: queue.serviceLevel?.percentage == null ? NaN : queue.serviceLevel.percentage / 100,
  serviceLevelEditable: queue.serviceLevelEditable,
  skillId: queue.skillId || null,
  skillIdEditable: queue.skillIdEditable,
  tag: queue.tag,
  tagEditable: queue.tagEditable,
  timezone: queue.timezone,
  timezoneEditable: queue.timezoneEditable,
  used: queue.used,
});

export const normalizeAcdQueues = (acdQueues: AcdQueue[]) =>
  acdQueues.map((acdQueue) => {
    const isDuplicate = !!acdQueues.find(
      (option) => option.queueName === acdQueue.queueName && option.id !== acdQueue.id
    );

    return {
      id: acdQueue.id,
      // TODO: Previously it was different value in label and in the list
      name: isDuplicate ? `${acdQueue.queueName} (${acdQueue.acdSourceQueueId})` : acdQueue.queueName,
    };
  });
